import SelectBox from "./SelectBoxPrimitive";
import YearDropdownItem from "./YearDropdownItem";
import { range } from "d3";
import { memo } from "react";

export enum YearSelectionRole {
  StartYear = "StartYear",
  EndYear = "EndYear",
  FixedYear = "FixedYear",
}

type YearItem = { label: string; value: number };

interface YearDropdownProps {
  /** The currently selected year value */
  value: number | undefined;
  /** Called when the user selects a new year */
  onChange: (year: number) => void;
  /** Minimum year available */
  yearMin: number;
  /** Maximum year available */
  yearMax: number;
  /** Accessible name for the toggle button (e.g. "Start Year"). */
  ariaLabel?: string;
}

const YearDropdown = ({
  value,
  onChange,
  yearMin,
  yearMax,
  ariaLabel,
}: YearDropdownProps) => {
  const items: YearItem[] = range(yearMin, yearMax + 1, 1)
    .map(
      (year: number): YearItem => ({
        label: String(year),
        value: year,
      }),
    )
    .reverse(); // Reversing here so that year values are in descending order

  const dispatchAction = ({ value: selectedValue }: { value: string | number }) => {
    onChange(Number(selectedValue));
  };

  let matchSelectedItem: YearItem | undefined = undefined;
  if (value !== undefined) {
    matchSelectedItem = items.find(
      (item: YearItem) => item.value === Number(value),
    );
  }

  return (
    <>
      <SelectBox
        items={items}
        hashFunction={(item: YearItem) => item.value}
        placeholder="Please select a year"
        ItemRenderComponent={YearDropdownItem}
        onChangeEvent={dispatchAction}
        selectedValueFromStore={matchSelectedItem}
        ariaLabel={ariaLabel}
      />
    </>
  );
};

export default memo(YearDropdown);
